import React from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { tesaBlue } from "../../styles/colors";

export interface UploadingFileViewProps {
  progress: number;
}

function UploadingFileView(props: UploadingFileViewProps) {
  const { progress } = props;
  return (
    <>
      <CircularProgress variant="determinate" value={progress} style={{ color: tesaBlue }} />
      <Box position="absolute">
        <Typography variant="caption" component="div" style={{ color: tesaBlue }} color="inherit">{`${Math.round(
          progress,
        )}%`}</Typography>
      </Box>
    </>
  );
}

export default UploadingFileView;
